export default __webpack_public_path__ + "static/media/logo.d2b9184d.png";